var _style, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 3000",
    style: {
      enableBackground: "new 0 0 5000 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#012169;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#C8102E;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 5000,
    height: 3000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2505.9,1366.3 0.3,3000 0.4,3000.1 0.7,3000.5 0.9,3000.8 639.8,3000.8 2505.9,1784.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2505.9,1366 0.1,2999.8 0,2999.9 0.1,3000.1 0.2,3000.2 0.5,3000.6 0.6,3000.8 456.3,3000.8  1956.6,2022.6 1956.6,2022.6 2505.9,1664.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2505.9,948.6 0.1,2582.4 0.1,2999.8 0,2999.9 0.1,3000.1 0.1,3000.3 0.2,3000.2 0.4,3000.1  2505.9,1366.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2505.9,1634 1.1,0.8 0.4,0.4 0.3,0.5 0.9,0.8 0.1,0.8 0.1,418 2505.9,2051.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2505.9,1633.7 1.6,0.8 0.6,0.1 0.3,0 0.2,0.2 0.4,0.4 0.3,0.5 0.9,0.8 0.1,0.8 0.1,298.3  2505.9,1932.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2505.9,1216.3 641.7,0.8 1.6,0.8 0.6,0.1 0.4,0.4 0.3,0.5 0.9,0.8 2505.9,1634.2  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2494.1,1633.7 4999.7,0 4999.6,-0.1 4999.3,-0.5 4999.1,-0.8 4360.2,-0.8 2494.1,1215.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2494.1,1634 4999.9,0.2 5000,0.1 4999.9,-0.1 4999.8,-0.2 4999.5,-0.6 4999.4,-0.8 4543.7,-0.8  3043.4,977.4 3043.4,977.4 2494.1,1335.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2494.1,2051.4 4999.9,417.6 4999.9,0.2 5000,0.1 4999.9,-0.1 4999.9,-0.3 4999.8,-0.2 4999.6,-0.1  2494.1,1633.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2494.1,1366 4998.9,2999.2 4999.6,2999.6 4999.7,2999.5 4999.1,2999.2 4999.9,2999.2 4999.9,2582  2494.1,948.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2494.1,1366.3 4998.4,2999.2 4999.4,2999.9 4999.7,3000 4999.8,2999.8 4999.6,2999.6 4999.7,2999.5  4999.1,2999.2 4999.9,2999.2 4999.9,2701.7 2494.1,1067.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2494.1,1783.7 4358.3,2999.2 4998.4,2999.2 4999.4,2999.9 4999.6,2999.6 4999.7,2999.5  4999.1,2999.2 2494.1,1365.8  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 1000,
    className: "st1",
    width: 5000,
    height: 1000
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2000,
    className: "st1",
    width: 1000,
    height: 3000
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1150,
    className: "st2",
    width: 5000,
    height: 700
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2150,
    className: "st2",
    width: 700,
    height: 3000
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.ace9ee9da424166af0d6ce8c0281c277.svg";
export { ForwardRef as ReactComponent };